module.exports = __webpack_public_path__ + "3f9c2f92f16bc2d1616c0a2b59d223ef.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/trailer_preview-460.webp.png
// module id = 562
// module chunks = 0